"use strict";

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mutex = void 0;

var Mutex = /*#__PURE__*/function () {
  function Mutex() {
    _classCallCheck(this, Mutex);

    this._queue = [];
    this._locked = false;
  }

  _createClass(Mutex, [{
    key: "acquire",
    value: function () {
      var _acquire = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var isLocked, releaseFunc;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isLocked = this.isLocked();
                releaseFunc = new Promise(function (resolve) {
                  return _this._queue.push(resolve);
                });

                if (!isLocked) {
                  this._tick();
                }

                return _context.abrupt("return", releaseFunc);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function acquire() {
        return _acquire.apply(this, arguments);
      }

      return acquire;
    }()
  }, {
    key: "isLocked",
    value: function isLocked() {
      return this._locked;
    }
  }, {
    key: "runExclusive",
    value: function () {
      var _runExclusive = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(worker) {
        var release;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.acquire();

              case 2:
                release = _context2.sent;
                _context2.prev = 3;
                _context2.next = 6;
                return worker();

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
                _context2.prev = 7;
                release();
                return _context2.finish(7);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3,, 7, 10]]);
      }));

      function runExclusive(_x) {
        return _runExclusive.apply(this, arguments);
      }

      return runExclusive;
    }()
  }, {
    key: "_tick",
    value: function _tick() {
      var _this2 = this;

      var releaseFunc = this._queue.shift();

      if (!releaseFunc) {
        return;
      }

      var nextReleaseFunc = function nextReleaseFunc() {
        _this2._locked = false;

        _this2._tick();
      };

      this._locked = true;
      releaseFunc(nextReleaseFunc);
    }
  }]);

  return Mutex;
}();

exports.Mutex = Mutex;